import type {
    Body,
    Brand,
    ContractDetails,
    DateFilter,
    DeliveryDates,
    Equipment,
    Garage,
    GarageChain,
    Gearbox,
    Generation,
    Key,
    Motorization,
    NumberPlate,
    Organization,
    PhoneInput,
    Place,
    PremiumService,
    Service,
    Slot,
} from "@App/types";
import {ActionType} from "@App/state/action-types";
import type {Dispatch} from "redux";
import type {Action} from "@App/state/actions";

export * from '@App/state/action-creators/auth'


export const chooseService = (service: Service) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHOOSE_SERVICE,
            payload: service
        })
    }
}


export const chooseOrganization = (organization: Organization) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHOOSE_ORGANIZATION,
            payload: organization
        })
    }
}

export const chooseBrand = (brand: Brand) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHOOSE_BRAND,
            payload: brand
        })
    }
}

export const chooseGeneration = (generation: Generation) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHOOSE_GENERATION,
            payload: generation
        })
    }
}

export const chooseMotorization = (motorization: Motorization) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHOOSE_MOTORIZATION,
            payload: motorization
        })
    }
}

export const setKey = (key: Key) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_KEY,
            payload: key
        })
    }
}

export const chooseBody = (body: Body) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHOOSE_BODY,
            payload: body
        })
    }
}

export const chooseGearbox = (gearbox: Gearbox) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHOOSE_GEARBOX,
            payload: gearbox
        })
    }
}

export const setMileage = (mileage: number) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_MILEAGE,
            payload: mileage
        })
    }
}

export const setRegistrationDate = (registrationDate: Date) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_REGISTRATION_DATE,
            payload: registrationDate
        })
    }
}

export const addEquipment = (equipment: Equipment) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_EQUIPMENT,
            payload: equipment
        })
    }
}

export const removeEquipment = (equipment: Equipment) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.REMOVE_EQUIPMENT,
            payload: equipment
        })
    }
}

export const chooseGarage = (garage: Garage) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHOOSE_GARAGE,
            payload: garage
        })
    }
}

export const removeGarage = () => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.REMOVE_GARAGE,
        })
    }
}

export const choosePlace = (place: Place) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHOOSE_PLACE,
            payload: place
        })
    }
}

export const chooseSlot = (slot: Slot) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHOOSE_SLOT,
            payload: slot
        })
    }
}

export const addPremiumService = (premiumService: PremiumService) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_PREMIUM_SERVICE,
            payload: premiumService
        })
    }
}

export const removePremiumService = (premiumService: PremiumService) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.REMOVE_PREMIUM_SERVICE,
            payload: premiumService
        })
    }
}

export const clearPremiumServices = (premiumServices: PremiumService[]) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CLEAR_PREMIUM_SERVICES,
            payload: premiumServices
        })
    }
}

export const setFirstName = (firstName: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_FIRST_NAME,
            payload: firstName
        })
    }
}

export const setSalutation = (salutation: number) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_SALUTATION,
            payload: salutation
        })
    }
}

export const setLastName = (lastName: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LAST_NAME,
            payload: lastName
        })
    }
}

export const setEmail = (email: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_EMAIL,
            payload: email
        })
    }
}

export const setPhone = (phone: PhoneInput) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_PHONE,
            payload: phone
        })
    }
}

export const setNumberPlate = (numberPlate: NumberPlate) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_NUMBERPLATE,
            payload: numberPlate
        })
    }
}

export const changeDatesFilter = (dates: DateFilter) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_DATES_FILTER,
            payload: dates
        })
    }
}

export const changeDistanceFilter = (distance: number) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_DISTANCE_FILTER,
            payload: distance
        })
    }
}

export const changeNameFilter = (search: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_NAME_FILTER,
            payload: search
        })
    }
}


export const changeSortByFilter = (sortBy: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_SORT_BY_FILTER,
            payload: sortBy
        })
    }
}

export const changeBrandFilter = (brand: Brand) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_BRAND_FILTER,
            payload: brand
        })
    }
}

export const changeBevSupportFilter = (bevSupport: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_BEV_SUPPORT_FILTER,
            payload: bevSupport
        })
    }
}

export const changeCommercialVehicleSupportFilter = (commercialVehicleSupport: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_COMMERCIAL_VEHICLE_SUPPORT_FILTER,
            payload: commercialVehicleSupport
        })
    }
}


export const addSubRepair = (subRepair: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_SUB_REPAIR,
            payload: subRepair
        })
    }
}


export const removeSubRepair = (subRepair: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.REMOVE_SUB_REPAIR,
            payload: subRepair
        })
    }
}

export const setContractDetails = (contractDetails: ContractDetails) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_CONTRACT_DETAILS,
            payload: contractDetails
        })
    }
}

export const updateContractDetails = (contractDetails, updatedValues) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.UPDATE_CONTRACT_DETAILS,
            payload: Object.assign({}, contractDetails, updatedValues)
        })
    }
}

export const setDeliveryDates = (deliveryDates: DeliveryDates) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_DELIVERY_DATES,
            payload: deliveryDates
        })
    }
}


export const dismissModal = (dismiss: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.DISMISS_MODAL,
            payload: dismiss
        })
    }
}


export const changeBookableFilter = (bookable: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_BOOKABLE_FILTER,
            payload: bookable
        })
    }
}


export const changeOnlyManufacturerFilter = (onlyManufacturer: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_ONLYMANUFACTURER_FILTER,
            payload: onlyManufacturer
        })
    }
}

export const changeGarageChain = (garageChains: GarageChain[]) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_GARAGE_CHAINS,
            payload: garageChains
        })
    }
}

export const changeShowAsNonBookableFilter = (showAsNonBookable: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_SHOW_AS_NONBOOKABLE,
            payload: showAsNonBookable
        })
    }
}

export const setRentalCarSelection = (rentalCarSelection: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_RENTAL_CAR_SELECTION,
            payload: rentalCarSelection
        })
    }
}
